export default __webpack_public_path__ + "static/media/statisticsTable.8d48c62d.png";